import {InputHTMLAttributes} from "react";
import classNames from "classnames";
import styles from "./Input.module.scss";

type Props = InputHTMLAttributes<HTMLInputElement> & {
    variant?: "site" | "admin";
    outlined?: boolean;
    invalid?: boolean;
};

export const Input = (
    {
        variant = "site",
        type = "text",
        className,
        disabled,
        id,
        name,
        outlined = false,
        invalid,
        ...otherProps
    }: Props
) => {
    const classes = classNames(
        styles.input,
        styles[variant],
        {
            [styles.outlined]: outlined,
            [styles.invalid]: invalid,
        },
        className,
    );

    return (
        <input
            {...otherProps}
            id={id ?? name}
            name={name}
            type={type}
            disabled={disabled}
            className={classes}
        />
    );
}
